module.exports = __webpack_public_path__ + "12c8825fa08145ddbc64643225caadf7.pdf";